import "./TeamCard.css";

function TeamCard({ image, name, title }) {
  return (
    <article className="team-card">
      <img src={image} alt={name} />
      <p>{name}</p>
      <p className="small-font">({title})</p>
    </article>
  );
}

export default TeamCard;
